import { inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SeoService } from '@shared/services/seo.service';
import { UserService } from '@shared/services/user.service';
import { AccountService } from '@shared/services/account.service';
import { AuthService } from '@shared/services/auth.service';
import { ENVIRONMENT_CONFIG } from '@shared/injection-token/environment-config';
import { getLang } from '@shared/utils/get-lang';

@Injectable()
export abstract class AbstractAppComponent {
  protected readonly seoService = inject(SeoService);
  protected readonly userService = inject(UserService);
  protected readonly accountService = inject(AccountService);
  protected readonly authService = inject(AuthService);
  protected readonly translateService = inject(TranslateService);
  protected readonly environmentConfig = inject(ENVIRONMENT_CONFIG);

  constructor(title: string, description: string, translate = false) {
    this.translateService.addLangs(this.environmentConfig.langs);
    if (this.authService.isSignIn()) {
      this.accountService.getAccount().subscribe((user) => this.userService.setUser(user));
    }
    const lang = getLang(this.environmentConfig);
    this.translateService.use(lang);
    if (translate) {
      this.translateService.onLangChange.subscribe(() => {
        this.seoService.addMetas(`description`, this.translateService.instant(description));
        this.seoService.addTitle(`${this.translateService.instant(title)} | ${this.environmentConfig.config.name}`);
      });
    } else {
      this.seoService.addMetas(`description`, description);
      this.seoService.addTitle(`${title} | ${this.environmentConfig.config.name}`);
    }
  }
}
